module.exports = __webpack_public_path__ + "static/img/ic_video_record.a97f9d4a.png";